import React, { Component } from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';

class Introduction extends Component {
  render() {
    const { tittel, ingress } = this.props;

    return (
      <Container text textAlign="center">
        <Header as="h1">{tittel}</Header>

        <Segment basic size="huge">
          {ingress}
        </Segment>
      </Container>
    );
  }
}

export default Introduction;



// WEBPACK FOOTER //
// ./src/Form/Introduction.js